import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect } from 'react';
import { initGA, logPageView } from './analytics';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppChat from './components/WhatsAppChat';
import Loader from './components/Loader';
import { HelmetProvider } from 'react-helmet-async';

const Home = lazy(() => import('./pages/Home'));
const LandingPage = lazy(() => import('./pages/LandingPage'));
const About = lazy(() => import('./pages/About'));
const Services = lazy(() => import('./pages/Services'));
const Features = lazy(() => import('./pages/Features'));
const Contact = lazy(() => import('./pages/Contact'));
const Project = lazy(() => import('./pages/Project'));
const Terms = lazy(() => import('./pages/Terms'));
const WhyUs = lazy(() => import('./pages/Whyus'));
const OurStrength = lazy(() => import('./pages/OurStrength'));
const Construction = lazy(() => import('./pages/Construction'));
const Maintenance = lazy(() => import('./pages/Maintenance'));
const AfterSales = lazy(() => import('./pages/AfterSales'));
const MetalFitOut = lazy(() => import('./pages/MetalFitOut'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const ContractingConstruction = lazy(() => import('./pages/Contracting_Construction'));
const MetalFabrication = lazy(() => import('./pages/Metal'));
const CivilConstruction = lazy(() => import('./pages/Civil _construction'));
const FitOutServices = lazy(() => import('./pages/Fit_out'));
const OngoingProjects = lazy(() => import('./pages/OngoingProjects'));
const Clients = lazy(() => import('./pages/Client'));
const RecentProjectsCarousel = lazy(() => import('./pages/Recentproject'));
const VisionMissionPage = lazy(() => import('./pages/Vission'));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Suspense fallback={<Loader />}>
          <AppContent />
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/landing';

  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);

  // Track page views on route change
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return (
    <>
      {!isLandingPage && <Header />}

      <main style={{ padding: isLandingPage ? "0" : "0rem" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/features" element={<Features />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/project" element={<Project />} />
          {/* <Route path="/team" element={<Team />} /> */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/whyus" element={<WhyUs />} />
          <Route path="/our-strength" element={<OurStrength />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/after-sales" element={<AfterSales />} />
          <Route path="/metal-fitout" element={<MetalFitOut />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/contracting-construction" element={<ContractingConstruction />} />
          <Route path="/metal" element={<MetalFabrication />} />
          <Route path="/civil" element={<CivilConstruction />} />
          <Route path="/fit-out" element={<FitOutServices />} />
          <Route path="/ongoing" element={<OngoingProjects />} />


          <Route path="/client" element={<Clients />} /> {/* Assuming this is a typo and should be WhyUs */}
          <Route path="/recent-projects" element={<RecentProjectsCarousel />} /> {/* Assuming this is a typo and should be Project */}



          <Route path="/vissionmission" element={<VisionMissionPage />} /> {/* Assuming this is a typo and should be Project */}


          {/* Redirect to Home for any unmatched routes */}
          {/* Add more routes as needed */}
        </Routes>
      </main>

      {!isLandingPage && <Footer />}
      {!isLandingPage && <WhatsAppChat />}
    </>
  );
}

export default App;
